import TYPES from '../types';

export default payload => {
  return {
    type: TYPES.OPEN_MODAL,
    payload,
  };
};
